module.exports = __webpack_public_path__ + "img/validation-icon.cbd778d4.svg";